import * as TYPES from '../types';
import { REDUX_CONSTANT } from '../../constants';

const initialState = {
    vendorTypeList: [
        { name: 'All', type: 'item' },
        { name: 'For-Profit', type: 'item' },
        { name: 'Non-Profit', type: 'item' }
    ],
    userRoleList: [],
    vendorAPIAccess: [
        { name: 'Integration', type: 'item' },
        { name: 'Production', type: 'item' },
        { name: 'Both', type: 'item' }
    ]
};

export default function getUserManagementInformation(
    state = initialState,
    action
) {
    switch (action.type) {
        case REDUX_CONSTANT.GET_VENDOR_USER_LIST_DATA:
            return {
                ...state,
                isLoading: false,
                vendorUsersData:
                    action.payload &&
                    action.payload.items &&
                    action.payload.items.length > 0
                        ? action.payload.items
                        : [],
                recordCountForVendorDetails: action.payload.recordCount,
                sortOrderForVendorDetails: action.payload.sortOrder,
                pageSizeForVendorDetails: action.payload.pageSize,
                pageNumberForVendorDetails: action.payload.pageNumber,
                vendorDetailsSearchText: action.payload.searchText,
                role: action.payload.role,
                vendorAPIAccess: initialState.vendorAPIAccess
            };

        case REDUX_CONSTANT.ADD_USER_DATA:
            return {
                ...state,
                vendorAddUserData: action.payload,
                isLoading: false
            };

        case REDUX_CONSTANT.UPDATE_USER_DATA:
            return {
                ...state,
                vendorUpdateUserData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.DEACTIVATE_USER_DATA:
            return {
                ...state,
                deactivateVendorUserData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.ALL_USER_ROLES_DATA:
            return {
                ...state,
                userRoleList: getUserRoleListData(action.payload),
                isLoading: false
            };

        case REDUX_CONSTANT.PLATFORM_USER_INVITATION_DATA:
            return {
                ...state,
                isLoading: false,
                platformUserInvitationData: action.payload
            };

        case REDUX_CONSTANT.LOGOUT_RESET:
            state = initialState;
            return {
                ...state
            };

        case TYPES.ON_LOAD:
            return {
                ...state,
                isLoading: true
            };

        case TYPES.ERROR:
            return {
                ...state,
                isLoading: false,
                vendorManagementData:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_MANAGEMENT_DATA
                        ? []
                        : state.vendorManagementData,
                vendorUsersData:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_USER_LIST_DATA
                        ? []
                        : state.vendorUsersData,
                vendorAddUserData:
                    action.payload.title === REDUX_CONSTANT.ADD_USER_DATA
                        ? action.payload.msg
                        : state.vendorAddUserData,
                vendorUpdateUserData:
                    action.payload.title === REDUX_CONSTANT.UPDATE_USER_DATA
                        ? action.payload.msg
                        : state.vendorUpdateUserData,
                userRoleList:
                    action.payload.title === REDUX_CONSTANT.ALL_USER_ROLES_DATA
                        ? []
                        : state.userRoleList,
                platformUserInvitationData:
                    action.payload.title ===
                    REDUX_CONSTANT.PLATFORM_USER_INVITATION_DATA
                        ? action.payload.msg
                        : state.platformUserInvitationData
            };
        default:
            return state;
    }
}

/* Function create user roles array
 *
 * @param - payload - type (array of objects)
 *
 */
let getUserRoleListData = (payload) => {
    // Appending element All to an array
    let userRolesArray = [{ name: 'All', type: 'item' }];
    payload &&
        payload.length > 0 &&
        payload.map((item) => {
            userRolesArray.push({ name: item.role, type: 'item' });
        });
    return userRolesArray;
};
